import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.profilePage.pageTitle',
    defaultMessage: 'Il mio profilo',
    description: 'Title of the change password page',
  },
  disclaimerMyAzimut: {
    id: 'features.profileMenu.disclaimerMyAzimut',
    defaultMessage: 'My Azimut',
    description: "Text of disclaimer 'MyAzimut'",
  },
  labelIdentificationNumberField: {
    id: 'features.profileMenu.labelIdentificationNumberField',
    defaultMessage: 'Codice cliente',
    description: 'Label of identification number field',
  },
  labelEmailField: {
    id: 'features.profileMenu.labelEmailField',
    defaultMessage: 'Email',
    description: 'Label of email field',
  },
  labelEmailChangedField: {
    id: 'features.profileMenu.labelEmailChangedField',
    defaultMessage: 'Email in attesa di modifica',
    description: 'Label of email changed field',
  },
  labelPhoneNumberField: {
    id: 'features.profileMenu.labelPhoneNumberField',
    defaultMessage: 'Numero di cellulare',
    description: 'Label of phone number field',
  },
  labelPhoneNumberChangedField: {
    id: 'features.profileMenu.labelPhoneNumberChangedField',
    defaultMessage: 'Numero di cellulare in attesa di modifica',
    description: 'Label of phone number changed field',
  },
  labelSecondaryPhoneNumberField: {
    id: 'features.profileMenu.labelSecondaryPhoneNumberField',
    defaultMessage: 'Numero di cellulare secondario',
    description: 'Label of secondary phone number field',
  },
  labelPasswordField: {
    id: 'features.profileMenu.labelPasswordField',
    defaultMessage: 'Password',
    description: 'Label of password field',
  },
  labelSignUpdateButton: {
    id: 'features.profileMenu.labelSignUpdateButton',
    defaultMessage: 'Firma Modifica',
    description: 'Label of the button for sign the update',
  },
  disclaimer: {
    id: 'features.profileMenu.disclaimer',
    defaultMessage:
      'Sarà possibile modificare i contatti una volta conclusa la verifica della pratica di Onboarding',
    description: 'Disclaimer',
  },
  disclaimer2: {
    id: 'features.profileMenu.disclaimer2',
    defaultMessage:
      'Non è possibile procedere con la richiesta di modifica dei propri contatti, perché sono presenti documenti da firmare',
    description: 'Disclaimer2',
  },
  disclaimer3: {
    id: 'features.profileMenu.disclaimer3',
    defaultMessage:
      'Non è possibile modificare il numero di cellulare, in quanto è in corso la modifica dell’indirizzo email',
    description: 'Disclaimer3',
  },
  disclaimer4: {
    id: 'features.profileMenu.disclaimer4',
    defaultMessage:
      'Non è possibile modificare l’indirizzo email, in quanto è in corso la modifica del numero di cellulare',
    description: 'Disclaimer4',
  },
  disclaimer5: {
    id: 'features.profileMenu.disclaimer5',
    defaultMessage:
      'Non è possibile modificare i dati di contatto per documento d’identità scaduto',
    description: 'Disclaimer5',
  },
});
